import { createAction, props } from '@ngrx/store';

export enum Actions {
    Init = '[ShowTags] Init',
    SelectShowTags = '[ShowTags] ShowTags Selected',
    SelectShowTagsFailure = '[ShowTags] ShowTags Selection Failure',
    SelectShowTagsSuccess = '[ShowTags] ShowTags Selection Success',
}

export const ShowTagsActions = {

    init: createAction(Actions.Init),
    selectShowTags: createAction(Actions.SelectShowTags, props<{ showTags: string }>()),
    selectShowTagsFailure: createAction(Actions.SelectShowTagsFailure, props<{ error: any }>()),
    selectShowTagsSuccess: createAction(Actions.SelectShowTagsSuccess, props<{ showTags: string }>()),
};

export const AsyncActions = {
    loadActions: [
        ShowTagsActions.selectShowTags,
    ],
    successActions: [
        ShowTagsActions.selectShowTagsSuccess,
    ],
    errorActions: [
        ShowTagsActions.selectShowTagsFailure,
    ]
};
